var angular = require('angular');
require('angular-socialshare');
var module =  angular.module("app.directives");
var social = require('../../social')

module.directive("socialShare", function ($timeout, $location) {
  return {
    restrict: "E",
    template: require("./index.pug"),
    replace:true,
    transclude:true,
    scope: {
      url: "@",
      text: "@",
      description: "@",
      media: "@",
      applicantmedia: "@",
      type: "@",
      reference: "@",
      layout: "@",
      toggleImage: "@"
    },
    link: function (scope, el, attrs, ctrl, transclude) {
        var media = scope.media || scope.applicantmedia || "";
      
        scope.open = false;
        scope.social = social;
        scope.fbAppId = window.conf.fb_app_id;
        scope.description = scope.description.length > 100 ? scope.description.substring(0, 100) : scope.description;
        scope.isMobile =  /Mobi|Android/i.test(navigator.userAgent);

        if (!scope.type) scope.Type == "project";
        scope.shareUrl = window.conf.base_uri
            + "share?title=" + encodeURIComponent(scope.text)
            + "&description=" + encodeURIComponent(scope.description)
            + "&imageUrl=" + media.replace(/%20/g, "").split(" ").join("")
            + "&projectRef=" + scope.reference
            + "&type=" + encodeURIComponent(scope.type);

        scope.whatsAppShareUrl = scope.shareUrl
            + "&utm_source=WhatsApp&utm_medium=Social&utm_campaign=WhatsApp_platform_links";

        scope.twitterShareUrl = window.conf.base_uri
            + "share?projectRef=" + scope.reference
            + "&type=" + encodeURIComponent(scope.type);
        scope.host = window.conf.base_uri;

      scope.toggle = function(e){
        // display / hide the buttons.
        // If it uses inline buttons (right of toggle button), set the position.
        e.target.blur();
        if (scope.layout == 'inline'){
          var triggerWidth = $('.social-share-toggle img').first().innerWidth();
          $('.social-share-buttons').css(
            {
              'left': triggerWidth + 10 + 'px',
              'top' : 0
            }
          );
        }
        scope.open = !scope.open;
      }

      scope.$watch('open', function(val){
        // enable/disable an event to close the buttons on body-click
        if (val) {
          angular.element(document.body).on('click', onbodyclick);
        } else {
          angular.element(document.body).off('click', onbodyclick);
        }
      })

      // OnBodyClick - close the buttons
      function onbodyclick(e){
        if (e.target !== el[0] && !el[0].contains(e.target)) {
          $timeout(function(){
            scope.open = false;
          })
        }
      }

      // OnDestroy - remove OnBodyClick Handler
      scope.$on('$destroy', function () {
          angular.element(document.body).off('click', onbodyclick);
      });

      // Transclude handler
      transclude(scope, function(clone, scope) {
          if (!clone.length) return;
          $(el).find('.social-share-toggle').empty().append(clone);
      });

      setTimeout(function () {
          // Find the whatsAppLink - send a "SocialShareReady" event to it.
          var event = new Event('socialshareready');
          var whatsAppLink = $(el).find('a[socialshare-provider="whatsapp"]')[0];
          if (whatsAppLink) whatsAppLink.dispatchEvent(event);
      }, 500);
    },
  };
});
